/* eslint-disable */
import { HttpClient, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { toQueryString } from '../../api-helpers';
import { DownloadDetailDto, fixDownloadDetailDtoFromJson } from '../dto/download-detail-dto';

export interface GetDownloadGetDetailQueryParams {
  downloadId?: number;
}

export interface GetDownloadGetDetailParams {
  query: GetDownloadGetDetailQueryParams;
}

export function httpGetDownloadGetDetail(http: HttpClient, data: GetDownloadGetDetailParams, options?: { reportProgress?: boolean; observe?: 'body' }): Observable<DownloadDetailDto>;
export function httpGetDownloadGetDetail(http: HttpClient, data: GetDownloadGetDetailParams, options?: { reportProgress?: boolean; observe?: 'events' }): Observable<HttpEvent<DownloadDetailDto>>;
export function httpGetDownloadGetDetail(http: HttpClient, data: GetDownloadGetDetailParams, options: { reportProgress?: boolean; observe?: 'body' | 'events' } = {}): Observable<any> {
  return http.get<DownloadDetailDto>(`{placeholder}/Download/GetDetail?${toQueryString(data.query)}`, options as any).pipe(
    tap((eventOrDto) => {
      const dto = eventOrDto instanceof HttpResponse ? eventOrDto.body : options.observe === 'events' ? null : eventOrDto as unknown as DownloadDetailDto;
      fixDownloadDetailDtoFromJson(dto);
    })
  );
};

export const urlGetDownloadGetDetail = (baseUrl: string, data: GetDownloadGetDetailParams) => {
  return `${baseUrl}/Download/GetDetail?${toQueryString(data.query)}`;
};
